import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SelectField from '@wix/da-ds/pkg/Dropdown/select/SelectField';
import { DropdownOption } from '@wix/da-ds/pkg/Dropdown/types';
import { useSubmitField } from '../../../hooks/useSubmitField';

export type OAuth2ClientType = 'confidential' | 'public';

const OAuth2ClientTypeField: React.FC<{}> = () => {
  const { t } = useTranslation();
  const {
    id,
    field: { value, onChange },
  } = useSubmitField('oauth2ClientType', {
    initAdapter: ({ app }) => (app?.oauth2ClientType as OAuth2ClientType) ?? 'confidential',
    submitAdapter: ({ oauth2ClientType }) => ({
      oauth2_client_type: oauth2ClientType,
    }),
  });

  const items = useMemo<DropdownOption[]>(
    () => [
      {
        label: t('deviationSubmit.form.app.oauth2ClientType.confidential'),
        value: 'confidential' as const,
        selected: value === 'confidential',
      },
      {
        label: t('deviationSubmit.form.app.oauth2ClientType.public'),
        value: 'public' as const,
        selected: value === 'public',
      },
    ],
    [t, value]
  );

  return (
    <SelectField
      id={id}
      label={t('deviationSubmit.form.app.oauth2ClientType.label')}
      items={items}
      value={value}
      onSelect={onChange}
      withBlankOption={false}
      noBottomSpacing={false}
    />
  );
};
OAuth2ClientTypeField.displayName = 'OAuth2ClientTypeField';

export default OAuth2ClientTypeField;
